<ng-container *ngIf="state$ | async; let state">
    <div class="zas-row zas-headline-3">Beratungsfelder</div>

    <zbd-list
        [collection]="options"
        [template]="option"
        [columnNumber]="3"
        class="zas-row"
    ></zbd-list>

    <zbd-global-occasion-section
        *ngFor="
            let section of state.globalOccasion.GlobalOccasionSections;
            trackBy: trackEntity
        "
        [section]="section"
        [persistence]="persistence"
        [state]="state"
        [validity]="validity.sections[section.Id]"
        (delete-section)="deleteSection($event)"
    >
    </zbd-global-occasion-section>

    <ng-template #option let-item>
        <zbd-input
            type="checkbox"
            appearance="touch"
            (value-change)="selectionChanged(state, item, !!$event)"
            [label]="item.label"
            [value]="!isAvailable(state, item)"
        >
        </zbd-input>
    </ng-template>
</ng-container>
